export default __webpack_public_path__ + "static/media/goal.2d184c6e.png";